import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { DocumentFileLineData } from "@interfaces/data/documentFileLineData";
import { MarkOutsideProcessContractMovementAsReceivedDto } from "@interfaces/dto/markOutsideProcessContractMovementAsReceivedDto.interface";
import { OutsideProcessContract } from "@interfaces/models/outsideProcessContract.interface";
import { OutsideProcessContractContingencySupplier } from "@interfaces/models/outsideProcessContractContingencySupplier.interface";
import { OutsideProcessContractMovement } from "@interfaces/models/outsideProcessContractMovement.interface";
import { OutsourcedSpecification } from "@interfaces/models/outsourcedSpecification.interface";
import { Part } from "@interfaces/models/part.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { SupplierContact } from "@interfaces/supplierContact.interface";
import { FileService } from "@services/file.service";
import { OutsideProcessContractService } from "@services/outsideProcessContract.service";
import { OutsideProcessContractContingencySupplierService } from "@services/outsideProcessContractContingencySupplier.service";
import { OutsideProcessContractMovementService } from "@services/outsideProcessContractMovement.service";
import { OutsourcedSpecificationService } from "@services/outsourcedSpecification.service";
import { PartService } from "@services/part.service";
import { SupplierService } from "@services/supplier.service";
import { SupplierContactService } from "@services/supplierContact.service";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";

@Component({
	moduleId: module.id,
	selector: "outsideProcessContracts-id",
	styleUrls: ["outsideProcessContracts-id.css"],
	templateUrl: "outsideProcessContracts-id.html"
})
export class OutsideProcessContractsIdAdminComponent {
	activeProcessIds: number[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	item: OutsideProcessContract = new OutsideProcessContract();
	itemType = "Outside Process";
	mode = "view";
	outsideProcessContractContingencySuppliers: OutsideProcessContractContingencySupplier[] = [];
	outsideProcessContractMovements: OutsideProcessContractMovement[] = [];
	outsourcedSpecifications: OutsourcedSpecification[] = [];
	parts: Part[] = [];
	popupAddButtonOptions: any = { onClick: () => this.addNewDocument(), text: "Add Document", visible: true };
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupDocument: DocumentFileLineData = new DocumentFileLineData();
	popupMarkOutsideProcessContractMovementAsReceivedDto: MarkOutsideProcessContractMovementAsReceivedDto = new MarkOutsideProcessContractMovementAsReceivedDto();
	popupMarkOutsideProcessContractMovementAsReceivedDtoMaximumToSend = 0;
	popupOutsideProcessContingencySupplier: OutsideProcessContractContingencySupplier = new OutsideProcessContractContingencySupplier();
	popupTitle = "Add New Document";
	popupVisible = false;
	readOnly = true;
	relatedDocuments: DocumentFileLineData[] = [];
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	supplierContacts: SupplierContact[] = [];
	suppliers: Supplier[] = [];
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: OutsideProcessContractService, private fileService: FileService, private outsideContractContingencySupplierService: OutsideProcessContractContingencySupplierService, private outsideProcessContractMovementService: OutsideProcessContractMovementService, private outsourcedSpecificationService: OutsourcedSpecificationService, private partService: PartService, private supplierService: SupplierService, private supplierContactService: SupplierContactService) {
		this.buildButtons("view");
		this.getOutsourcedSpecifications();
		this.getParts();
		this.getSuppliers();

		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0]);
						this.edit();
					} else {
						this.getItem(params.id);
					}
				} else {
					this.create();
				}
			});

		this.deleteDocumentLink = this.deleteDocumentLink.bind(this);
		this.deleteOutsideProcessContractContingencySupplier = this.deleteOutsideProcessContractContingencySupplier.bind(this);
		this.downloadFileLink = this.downloadFileLink.bind(this);
		this.editOutsideProcessContractContingencySupplierPopup = this.editOutsideProcessContractContingencySupplierPopup.bind(this);
		this.markAsReceivedPopup = this.markAsReceivedPopup.bind(this);
		this.uploadDocument = this.uploadDocument.bind(this);
	}

	addNewDocument() {
		if (this.popupDocument.description === "") {
			alert("Please enter a description");
			return;
		}
		this.relatedDocuments.push(this.popupDocument);
		this.popupDocument = new DocumentFileLineData();
		this.closePopup();
	}

	addNewDocumentPopup() {
		this.popupDocument = new DocumentFileLineData();
		this.popupTitle = "Add New Document";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewDocument(), text: "Add Document", visible: true };
	}

	addNewOutsideProcessContractContingencySupplier() {
		this.outsideContractContingencySupplierService.createSingle(this.popupOutsideProcessContingencySupplier)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added Supplier");
					this.getOutsideProcessContractContingencySuppliers(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	addNewOutsideProcessContractContingencySupplierPopup() {
		this.popupOutsideProcessContingencySupplier = new OutsideProcessContractContingencySupplier();
		this.popupOutsideProcessContingencySupplier.outsideProcessContractId = this.item.id;
		this.popupTitle = "Add New Contingency Supplier";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewOutsideProcessContractContingencySupplier(), text: "Add Supplier", visible: true };
	}

	buildButtons(mode: string) {
		this.mode = mode;
		if (mode == "edit") {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [{ method: "addNewDocumentPopup", text: "Add Document" }];
		} else if (mode == "create") {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [{ method: "addNewDocumentPopup", text: "Add Document" }];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [{ method: "addNewOutsideProcessContractContingencySupplierPopup", text: "Add Contingency Supplier" }];
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	closePopup() {
		this.popupVisible = false;
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item = new OutsideProcessContract();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deleteDocumentLink(e: any) {
		const index = this.relatedDocuments.findIndex(d => d.lookupId === e.row.data.lookupId);
		this.relatedDocuments.splice(index, 1);

		return false;
	}

	deleteOutsideProcessContractContingencySupplier(e: any) {
		if (confirm("Are you sure you want to delete this contingency supplier? This will not affect existing movements.") == false) {
			return;
		}

		this.outsideContractContingencySupplierService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Relationship deleted!");
					this.getOutsideProcessContractContingencySuppliers(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}

	downloadFileLink(e: any) {
		const lookupId = Guid.parse(e.row.data.lookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	editOutsideProcessContractContingencySupplier() {
		this.outsideContractContingencySupplierService.updateSingleById(this.popupOutsideProcessContingencySupplier.id, this.popupOutsideProcessContingencySupplier)
			.subscribe(
				() => {
					this.toastService.success("Successfully Edited Supplier");
					this.getOutsideProcessContractContingencySuppliers(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	editOutsideProcessContractContingencySupplierPopup(e: any) {
		const outsideProcessContractContingencySupplierId = e.row.data.id;
		this.popupOutsideProcessContingencySupplier = this.outsideProcessContractContingencySuppliers.filter(o => o.id == outsideProcessContractContingencySupplierId)[0];
		this.popupTitle = "Edit Contingency Supplier";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editOutsideProcessContractContingencySupplier(), text: "Save Changes" };
		return false;
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "supplierId":
				this.getSupplierContacts(args.value);
				break;
		}
	}
	
	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.getOutsideProcessContractContingencySuppliers(this.item.id);
					this.getOutsideProcessContractMovements(this.item.id);
					this.getSupplierContacts(this.item.supplierId);
					this.relatedDocuments = JSON.parse(this.item.relatedDocuments);
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getOutsideProcessContractContingencySuppliers(outsideProcessContractId: number) {
		this.outsideContractContingencySupplierService.getByOutsideProcessContractId(outsideProcessContractId)
			.subscribe(
				(res: any) => {
					this.outsideProcessContractContingencySuppliers = res.response;
				},
				(err) => console.log(err)
			);
	}

	getOutsideProcessContractMovements(outsideProcessContractId: number) {
		this.outsideProcessContractMovementService.getByOutsideProcessContractId(outsideProcessContractId)
			.subscribe(
				(res: any) => {
					this.outsideProcessContractMovements = res.response;
				},
				(err) => console.log(err)
			);
	}

	getOutsourcedSpecifications() {
		this.outsourcedSpecificationService.getAll()
			.subscribe(
				(res: any) => {
					this.outsourcedSpecifications = res.response.items;
					this.outsourcedSpecifications.sort((a,b) => a.specification.localeCompare(b.specification));
				},
				(err) => console.log(err)
			);
	}

	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) => {
					this.parts = res.response.items;
					this.parts.sort((a,b) => a.partNumber.localeCompare(b.partNumber));
				},
				(err) => console.log(err)
			);
	}

	getSupplierContacts(supplierId: number) {
		this.supplierContactService.getContactsBySupplierId(supplierId)
			.subscribe(
				(res: any) => {
					this.supplierContacts = res.response;
					this.supplierContacts.sort((a,b) => a.displayName.localeCompare(b.displayName));
				},
				(err) => console.log(err)
			);
	}

	getSuppliers() {
		this.supplierService.getAll()
			.subscribe(
				(res: any) => {
					this.suppliers = res.response.items;
					this.suppliers.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isMarkReceivedButtonAvailable(e: any) {
		return (e.row.data.dateSent != null && e.row.data.dateSent != undefined) && (e.row.data.dateReceived == null || e.row.data.dateReceived == undefined);
	}

	markAsReceived() {
		this.outsideProcessContractMovementService.markOutsideProcessContractMovementAsReceived(this.popupMarkOutsideProcessContractMovementAsReceivedDto)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.getOutsideProcessContractMovements(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	markAsReceivedPopup(e: any) {
		this.popupMarkOutsideProcessContractMovementAsReceivedDto = new MarkOutsideProcessContractMovementAsReceivedDto();
		this.popupMarkOutsideProcessContractMovementAsReceivedDto.dateReceived = new Date();
		this.popupMarkOutsideProcessContractMovementAsReceivedDto.outsideProcessContractMovementId = e.row.data.id;
		this.popupMarkOutsideProcessContractMovementAsReceivedDto.quantityReceived = e.row.data.quantitySent;
		this.popupMarkOutsideProcessContractMovementAsReceivedDtoMaximumToSend = e.row.data.quantitySent;
		this.popupTitle = "Mark as Received";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.markAsReceived(), text: "Mark Received", visible: true };
	}

	stageToOP(cellInfo: any) {
		return "OP" + cellInfo.value + "0";
	}

	updateItem() {
		this.item.relatedDocuments = JSON.stringify(this.relatedDocuments);
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	uploadDocument(file: File) {
		const containerName = "machinefiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupDocument.lookupId = res.response[0].lookupId;
					this.popupDocument.fileName = res.response[0].name;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Document Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}
}